import { MultiSelect, ScrollArea, Stack, Tabs } from "@mantine/core";
import { SimpleBreadcrumbs } from "../../components/SimpleBreadcrumbs";
import { useIntl } from "react-intl";
import { useTRPC } from "../../trpc";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { AssistantUsageTab } from "./components/AssistantUsageTab";

export const Usage = () => {
  const intl = useIntl();
  const trpc = useTRPC();

  const [selectedAccounts, setSelectedAccounts] = useState<string[]>([]);
  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);

  const { data: accounts = [] } = useQuery(trpc.getAccounts.queryOptions());
  const { data: users = [] } = useQuery(trpc.getUsersForAccounts.queryOptions({
    accountIds: selectedAccounts.map(Number),
  }));

  return (
    <Stack gap={16} h="100%">
      <SimpleBreadcrumbs
        parent={intl.formatMessage({ defaultMessage: "Admin", id: "navigation.admin" })}
        current={intl.formatMessage({ defaultMessage: "Usage", id: "navigation.usage" })}
        description={intl.formatMessage({ defaultMessage: "Monitor platform usage", id: "text.monitorUsageDescription" })}
      />

      <Stack gap="xs">
        <MultiSelect
          onChange={setSelectedAccounts}
          value={selectedAccounts}
          label={intl.formatMessage({ defaultMessage: "Select accounts", id: "label.selectAccounts" })}
          data={accounts.map(({ id, name }) => ({ value: id.toString(), label: name }))}
          limit={20}
          searchable
        />
        <MultiSelect
          onChange={setSelectedUsers}
          value={selectedUsers}
          label={intl.formatMessage({ defaultMessage: "Select users (optional)", id: "label.selectUsers" })}
          data={users.map(({ id, email }) => ({ value: id.toString(), label: email }))}
          limit={20}
          searchable
        />
      </Stack>

      <Tabs defaultValue="assistant" h="100%">
        <Tabs.List>
          <Tabs.Tab value="assistant">
            {intl.formatMessage({ defaultMessage: "Assistant usage", id: "label.assistantUsage" })}
          </Tabs.Tab>
          <Tabs.Tab value="storage">
            {intl.formatMessage({ defaultMessage: "Storage usage", id: "label.storageUsage" })}
          </Tabs.Tab>
          <Tabs.Tab value="map">
            {intl.formatMessage({ defaultMessage: "Map usage", id: "label.mapUsage" })}
          </Tabs.Tab>
          <Tabs.Tab value="processing">
            {intl.formatMessage({ defaultMessage: "Processing usage", id: "label.processingUsage" })}
          </Tabs.Tab>
          <Tabs.Tab value="tile">
            {intl.formatMessage({ defaultMessage: "Tile usage", id: "label.tileUsage" })}
          </Tabs.Tab>
        </Tabs.List>

        <ScrollArea
          type="always"
          offsetScrollbars
          mt="-8px"
          mr="-32px"
          overscrollBehavior="auto"
        >
          <Tabs.Panel value="assistant">
            <AssistantUsageTab
              selectedAccounts={selectedAccounts}
              selectedUsers={selectedUsers}
            />
          </Tabs.Panel>

          <Tabs.Panel value="storage">
            <>
              {/* To be implemented */}
            </>
          </Tabs.Panel>

          <Tabs.Panel value="map">
            <>
              {/* To be implemented */}
            </>
          </Tabs.Panel>

          <Tabs.Panel value="processing">
            <>
              {/* To be implemented */}
            </>
          </Tabs.Panel>

          <Tabs.Panel value="tile">
            <>
              {/* To be implemented */}
            </>
          </Tabs.Panel>
        </ScrollArea>
      </Tabs>
    </Stack>
  );
};
